export function IntlGlobalProvider({ children }) {
  // Keep the 'intl' service reference
  return children;
}
